import Immutable from "seamless-immutable";
import {
  HIDE_LOADING,
  SHOW_ERROR,
  SHOW_LOADING,
  GET_BADGES_RESPONSES,
  UPDATE_BADGE,
  CREATE_BADGE
} from "./Types";
import api from "../../api";
import firebase from "firebase/compat/app";
import { addItem } from "../../transforms/ItemTransforms";

export function getBadgeResponses(includeCounts) {
  return async function (dispatch, getState) {
    try {
      dispatch({ type: SHOW_LOADING });

      let result = await api.badge.getBadges(includeCounts);
      if (!result.success) {
        dispatch({ type: SHOW_ERROR, message: result.error });
      } else {
        dispatch({ type: GET_BADGES_RESPONSES, data: result.data });
      }
    } catch (e) {
      console.error(e);
    } finally {
      dispatch({ type: HIDE_LOADING });
    }
  };
}

export function handleCreateBadgeRequest(data, icon) {
  return async function (dispatch, getState) {
    try {
      dispatch({ type: SHOW_LOADING });
      const photoId = `id-${Date.now()}`;
      const iconUrl = await uploadBadgeIcon('create', icon, photoId);
      data.iconUrl = iconUrl === "" ? "NONE" : iconUrl;

      const result = await api.badge.createBadge(data);
      if (!result.success) {
        dispatch({ type: SHOW_ERROR, message: result.error });
        return;
      }
      let { items } = getState().badge;
      items = Immutable.asMutable(items);

      items = addItem(items, result.data);

      dispatch({ type: CREATE_BADGE, items });
    } catch (e) {
      console.error(e);
    } finally {
      dispatch({ type: HIDE_LOADING });
    }
  };
}

export function handleEditBadgeRequest(id, data, icon) {
  return async function (dispatch, getState) {
    try {
      dispatch({ type: SHOW_LOADING });

      let { items } = getState().badge;

      let itemIdx = items.findIndex(item => item.id === id);
      if (itemIdx === -1) {
        dispatch({ type: SHOW_ERROR, message: "Could not find badge." });
        return;
      }

      const iconUrl = await uploadBadgeIcon('edit', icon, id);
      data.iconUrl = iconUrl === "" ? "NONE" : iconUrl;
      const result = await api.badge.editBadge(id, data);

      if (!result.success) {
        dispatch({ type: SHOW_ERROR, message: result.error });
        return;
      }

      items = Immutable.asMutable(items);
      items.splice(itemIdx, 1);

      items = addItem(items, result.data);

      dispatch({ type: UPDATE_BADGE, items });
    } catch (e) {
      console.error(e);
    } finally {
      dispatch({ type: HIDE_LOADING });
    }
  };
}

const uploadBadgeIcon = (type, icon, photoId) => {
  if (!icon) return "";
  return new Promise(async (resolve, reject) => {
    if (!icon) resolve("");
    else {
      const name = "badge_photo";
      const storageRef = type === 'create' ? firebase.storage().ref(`badges/temp/${photoId}`) : firebase.storage().ref(`badges/${photoId}`);;

      let uploadTask = storageRef.child(name).put(icon);

      try {
        uploadTask.on("state_changed", snapshot => {
        });

        let uploadedFile = await uploadTask;

        var newRef = firebase.storage().ref(uploadedFile.metadata.fullPath);
        var downloadURL = await newRef.getDownloadURL();
        if (type === 'create')
          resolve(uploadedFile.metadata.fullPath);
        else
        resolve(downloadURL);
      } catch (e) {
        console.warn("Caught item photo upload error:", e);
        resolve("")
      }    
    }
  });
};

export function handleDeleteBadgeRequest(id) {
  return async function (dispatch, getState) {
    try {
      dispatch({ type: SHOW_LOADING });

      let { items } = getState().badge;
      items = Immutable.asMutable(items);

      let itemIdx = items.findIndex(item => item.id === id);
      if (itemIdx === -1) {
        dispatch({ type: SHOW_ERROR, message: "Could not find badge." });
        return;
      }

      const result = await api.badge.deleteBadge(id);

      if (!result.success) {
        dispatch({ type: SHOW_ERROR, message: result.error });
        return;
      }

      items = Immutable.asMutable(items);
      items.splice(itemIdx, 1);

      dispatch({ type: UPDATE_BADGE, items });
    } catch (e) {
      console.error(e);
    } finally {
      dispatch({ type: HIDE_LOADING });
    }
  };
}